(() => {
  const SECTION_SELECTOR = '.oddit-section-faqs';
  const ITEM_SELECTOR = '[data-faq-item]';
  const TRIGGER_SELECTOR = '.oddit-section-faqs__trigger';
  const ACTIVE_CLASS = 'oddit-section-faqs__item--active';

  function toggleItem(item, expand) {
    const trigger = item.querySelector(TRIGGER_SELECTOR);
    const answer = item.querySelector('.oddit-section-faqs__answer');

    if (expand) {
      item.classList.add(ACTIVE_CLASS);
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (answer) answer.setAttribute('aria-hidden', 'false');
    } else {
      item.classList.remove(ACTIVE_CLASS);
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (answer) answer.setAttribute('aria-hidden', 'true');
    }
  }

  function handleClick(e) {
    const trigger = e.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;

    const item = trigger.closest(ITEM_SELECTOR);
    if (!item) return;

    const section = item.closest(SECTION_SELECTOR);
    if (!section) return;

    const isActive = item.classList.contains(ACTIVE_CLASS);

    // Close all items in this section
    section.querySelectorAll(ITEM_SELECTOR).forEach(function (faqItem) {
      toggleItem(faqItem, false);
    });

    // If it wasn't active, open it
    if (!isActive) {
      toggleItem(item, true);
    }
  }

  function initSection(section) {
    section.addEventListener('click', handleClick);
  }

  function destroySection(section) {
    section.removeEventListener('click', handleClick);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest(ITEM_SELECTOR);
    if (!item) return;

    var section = item.closest(SECTION_SELECTOR);
    if (!section) return;

    section.querySelectorAll(ITEM_SELECTOR).forEach(function (faqItem) {
      toggleItem(faqItem, false);
    });

    toggleItem(item, true);
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    var item = e.target.closest(ITEM_SELECTOR);
    if (!item) return;

    toggleItem(item, false);
  });
})();